import { statisticsApi, userApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const exportsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    salesExport: builder.mutation({
      query: ({ customStoreId, startDate, endDate }) => ({
        url: userApi(),
        method: 'POST',
        body: {
          data: { userId: customStoreId, dateFrom: startDate, dateTo: endDate },
          method: 'getCharges'
        }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Export']
    }),

    sendExport: builder.mutation({
      query: ({ exportData }) => ({
        url: statisticsApi(),
        method: 'POST',
        body: {
          data: exportData,
          method: 'requestExport'
        }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Export']
    }),

    userExport: builder.mutation({
      query: ({ exportData }) => ({
        url: userApi(),
        method: 'POST',
        body: {
          data: exportData,
          method: 'export'
        }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Export']
    })
  }),
  overrideExisting: false,
});

export const {
  useSalesExportMutation,
  useSendExportMutation,
  useUserExportMutation,
} = exportsApiSlice; 